import React, { ReactNode } from 'react';
import {ShimmeredDetailsList, Modal, Stack, Text, PrimaryButton, DefaultButton, IconButton, Icon, Dialog, IDialogContentStyles, IDialogStyles, DialogType, IColumn, IDetailsListProps, DetailsRow, DetailsList, SelectionMode } from "@fluentui/react";
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';

interface ICustomTable {
  items?: any[];
  columns?: IColumn[];
  onRowClick?: (item: any) => void;
  loadign?:boolean;
}

export interface ButtonProps {
  text: string;
  onClick: () => void;
  primary?: boolean;
}

export interface ICustomModalEmp {
  isOpen: boolean;
  title?: string;
  message?: string;
  buttons?: ButtonProps[];
  onDismiss?: () => void;
  showCloseButton?: boolean;
  question?: string;
  iconName?: string;
  message2?: string;
}

const CustomModalEmp: React.FC<ICustomModalEmp> = ({
  isOpen,
  title = "Cargando",
  message = "Aguarda unos instantes",
  buttons = [],
  onDismiss,
  showCloseButton = false,
  question,
  iconName,
  message2
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      isBlocking={true}
      styles={{
        main: {
          width: 400,
          padding: 0,
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          overflow: "hidden",
        },
      }}
    >
      {/* Barra azul superior */}
      <div
        style={{
          height: "6px",
          backgroundColor: "#0078D4",
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
        }}
      ></div>

{showCloseButton && (
        <IconButton
          iconProps={{ iconName: "Cancel" }}
          onClick={onDismiss}
          ariaLabel="Cerrar"
          styles={{
            root: {
              position: "absolute",
              top: 10,
              right: 10,
            },
          }}
        />
      )}

      <Stack horizontalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { padding: "20px" } }}>
      {iconName ? (
          <Icon iconName={iconName} styles={{ root: { fontSize: 42, color: "#0078D4" } }} />
        ) : (
          <Text variant="large" styles={{ root: { fontWeight: "bold" } }}>
            {title}
          </Text>
        )}
        {message2 && <Text>{message2}</Text>}
        <Text styles={{root:{textAlign:'center'}}} >{message}</Text>
        {question && <Text>{question}</Text>}
        <Stack horizontal tokens={{ childrenGap: 10 }}>
          {buttons.map((button, index) =>
            button.primary ? (
              <PrimaryButton key={index} text={button.text} onClick={button.onClick} />
            ) : (
              <DefaultButton key={index} text={button.text} onClick={button.onClick} />
            )
          )}
        </Stack>
      </Stack>
    </Modal>
  );
};


interface ICustomModal {
  hidden?: boolean;
  minWidth?: number;
  minHeight?: number;
  onDismiss?: () => void;
  title?: string;
  children?: ReactNode;
  icon?:string;
}

function CustomModalBody({ hidden, minWidth = 400, onDismiss, title, children,minHeight=500 ,icon=''}: ICustomModal) {
  const dragOptions = {
    moveMenuItemText: 'Move',
    closeMenuItemText: 'Close',
    menu: ContextualMenu,
  };

  const dialogStyles: Partial<IDialogStyles> = {
    main: {
      height: minHeight, 
    },
  };

  const dialogContentStyles: Partial<IDialogContentStyles> = {
    innerContent: {
      height: '100%',
    },
  };

  const titleIncon = ()=>{
    return(
      <div style={{display:'flex', alignItems:'center' ,gap:'10px'}}>
        <Icon iconName={icon} style={{fontSize:"25px", marginBottom:'-5px'}} />
        <div >{title}</div> 
      </div>
    );
  }

  return (
    <Dialog
      hidden={!hidden}
      minWidth={minWidth}
      onDismiss={onDismiss}
      dialogContentProps={{ type: DialogType.normal, title:titleIncon(), styles: dialogContentStyles }}
      modalProps={{ isBlocking: true, dragOptions: dragOptions, styles: dialogStyles }}
    >
      {children}
    </Dialog>
  );
}

function CustomTable({ items = [], columns, onRowClick,loadign=false }: ICustomTable) {

  const onRenderRow: IDetailsListProps['onRenderRow'] = (props) => {
    if (props) {
      return (
        <div
          onClick={() => {
            if (onRowClick) {
              onRowClick(props.item);
            }
          }}
        >
          <DetailsRow
            {...props}
            styles={{
              root: {
                backgroundColor: props.itemIndex % 2 === 0 ? '#f5f5f5' : 'transparent',
                selectors: {
                  ':hover': { backgroundColor: '#d9d8d8' },
                },
              },
            }}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <ShimmeredDetailsList
      items={items}
      columns={columns}
      setKey="none"
      selectionMode={SelectionMode.none}
      layoutMode={0} 
      enableShimmer={loadign}
      onRenderRow={onRenderRow}
      shimmerLines={3}
    />
  );
}

export  { CustomModalEmp, CustomModalBody, CustomTable};

